import { SavedReportsCard } from "@/Features/SavedReports";
import { saveEvidenceReport } from "../../../../api";

const EvidenceSavedReports = ({ reportInfo }) => (
  <SavedReportsCard
    reportInfo={reportInfo}
    saveReport={saveEvidenceReport}
    minHeight={425}
  />
);

export default EvidenceSavedReports;
